import { registerDocumentHeader } from './components/document-header';
import { registerPrintModal } from './components/print-modal';
import { registerWatermarkModal } from './components/watermark-modal';
import { register as registerViewer } from './dms-viewer';
import { registerViewerWithAnnotations } from './dms-viewer-with-annotations';
import { registerAlert, registerIcon, registerModal } from '@onviobr/ui-elements';
import { registerColorPalette } from './components/color-palette';
import { registerDownloadModal } from './components/download-modal';
import { registerBusyLoader } from './components/busy-loader';
export { default as DmsViewer } from './dms-viewer';
export { DmsViewerWithAnnotations } from './dms-viewer-with-annotations';
export { PdfTronElement, EventType } from './dms-viewer-interface';
import { defineCustomElements as registerCommonViewer } from '@onviobr/toolbox-file-viewer';
function exposeVersionNumber() {
  window.bmdms = window.bmdms || {};
  window.bmdms.viewer = {
    version: '58.3.9'
  };
}
export var register = function register() {
  registerIcon();
  registerAlert();
  registerModal();
  registerViewer();
  registerViewerWithAnnotations();
  registerDocumentHeader();
  registerPrintModal();
  registerColorPalette();
  registerWatermarkModal();
  registerBusyLoader();
  registerDownloadModal();
  registerCommonViewer();
  exposeVersionNumber();
};
